// Copyright (c) 2015-present Mattermost, Inc. All Rights Reserved.
// See LICENSE.txt for license information.
// @flow

export default {
    TEAM_TYPE_OPEN: 'O',
    TEAM_TYPE_INVITE: 'I',
};

